/*eslint-disable */
ace.define("theme/markddrive",["require","exports","module"], function(require, exports, module) {

  exports.isDark = true;
  exports.cssClass = "markddrive";

  // var dom = require("ace/lib/dom");
  // dom.importCssStylsheet("/src/ace_custom/theme-markddrive.css", document);
});
/*eslint-enable */



// WEBPACK FOOTER //
// ./src/ace_custom/theme-markddrive.js